import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { useKernelApi } from 'infrastructure/api';
import { EMPLOYEES_PATH } from 'domain/shared/employee';

const EMPLOYEE_NEXT_REVIEW_DATE_PATH = '/careerDevelopmentReviews/nextReviews';

const useEmployeeCareerNextReviewDateService = () => {
  const employeeId = useEmployeeId() || '';
  const parentResourceUrl = `${EMPLOYEES_PATH}/${employeeId}`;
  const { sendPutRequest } = useKernelApi();

  const update = async (request: any) => {
    const requestData = await sendPutRequest(`${parentResourceUrl}${EMPLOYEE_NEXT_REVIEW_DATE_PATH}`, {
      date: request.nextReviewDate,
    });
    const response = await requestData.json();
    return {
      nextReviewDate: response.date,
    };
  };

  return {
    update,
  };
};

export default useEmployeeCareerNextReviewDateService;
